import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.push.js";
import { mapGetters } from 'vuex';
export default {
  props: {
    showAppointLink: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    productId: {
      type: String
    },
    descriptionStyle: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['list', 'haslogin'])
  },
  methods: {
    toCar() {
      if (this.haslogin) {
        var _this$list$category$;
        sessionStorage.setItem('component', JSON.stringify({
          id: this.list._id,
          key: (_this$list$category$ = this.list.category[0]) === null || _this$list$category$ === void 0 ? void 0 : _this$list$category$.group_code
        }));
        this.$router.push('/service/details');
      } else {
        _message.warning('亲，请您先登录哦');
      }
    }
  }
};